<template>

  <svg viewBox="0 0 24 24" role="presentation" focusable="false" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.243 20.727a8.655 8.655 0 01-3.497-.711 9.129 9.129 0 01-2.842-1.924 9.142 9.142 0 01-1.92-2.846 8.688 8.688 0 01-.711-3.502c0-1.897.533-3.617 1.599-5.159C5.937 5.044 7.366 3.962 9.157 3.34a.934.934 0 01.91.122c.281.2.415.47.4.812a8.96 8.96 0 00.6 3.602 8.779 8.779 0 001.998 3.046 8.762 8.762 0 003.042 2.002 8.922 8.922 0 003.596.6c.385-.015.67.115.855.389.185.274.219.582.1.923-.651 1.779-1.743 3.206-3.275 4.28-1.532 1.075-3.245 1.612-5.14 1.612zm0-1.779a7.019 7.019 0 003.62-.978 7.034 7.034 0 002.62-2.69 11.003 11.003 0 01-3.62-.968 10.554 10.554 0 01-3.064-2.146 10.75 10.75 0 01-2.154-3.068 10.511 10.511 0 01-.954-3.624 6.93 6.93 0 00-2.676 2.634 7.167 7.167 0 00-.966 3.636c0 2.001.7 3.702 2.098 5.103 1.4 1.401 3.098 2.101 5.096 2.101z"/></svg>

</template>


<script>

  export default {"name":"icon-fbb3880626ae3f219898c83498b0e00f"}

</script>